import { PropsWithRef } from 'react';

interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function CopyIcon(props: PropsWithRef<Props>) {
  const { size = 17, className } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.76 4.24H13.3C14.1487 4.24 14.9626 4.57714 15.5627 5.17726C16.1629 5.77737 16.5 6.59131 16.5 7.44V13.3C16.5 14.1487 16.1629 14.9626 15.5627 15.5627C14.9626 16.1629 14.1487 16.5 13.3 16.5H7.44C6.59131 16.5 5.77737 16.1629 5.17726 15.5627C4.57714 14.9626 4.24 14.1487 4.24 13.3V12.76"
        stroke="currentColor"
      />
      <path
        d="M9.76 0.5H3.5C1.84315 0.5 0.5 1.84315 0.5 3.5V9.76C0.5 11.4169 1.84315 12.76 3.5 12.76H9.76C11.4169 12.76 12.76 11.4169 12.76 9.76V3.5C12.76 1.84315 11.4169 0.5 9.76 0.5Z"
        stroke="currentColor"
      />
    </svg>
  );
}
